<template>
  <div class="form-check" :class="{disabled}">

    <label class="form-check-label">
      <input type="checkbox" class="form-check-input" :disabled="disabled" v-model="model" />
      <span class="form-check-sign"></span>
      <span v-if="label" class="cbLabel">{{label}}</span>
    </label>

    <a v-if="help && link" :href="link" target="_blank"><i class="fa fa-question-circle dynamic_tooltip" data-toggle="tooltip" data-html="true" data-placement="top" :title="help + (link? '<div class=\'tooltip_link\'>Click <i class=\'fa fa-question-circle\'></i> for more info</div>' : '')"></i></a>
    <i v-else-if="help" class="fa fa-question-circle dynamic_tooltip" data-toggle="tooltip" data-html="true" data-placement="top" :title="help"></i>
  </div>
</template>
<script>
  export default{

    name: 'base-checkbox',

    props: {
      label: String,
      disabled: Boolean,
      checked: Boolean,
      help: String,
      link: String
    },

    data () {
      return {}
    },

    computed: {
      model: {
        get () {
          return this.checked
        },
        set(check) {
          this.$emit('input', check)
        }
      },
    }
  }
</script>

<style scoped>
  .form-check .form-check-label {
    padding-left: 25px;
  }
  .form-check-sign::before,
  .form-check-sign::after{
    margin-top: 1px!important;
  }
  .cbLabel{
    font-size: 16px;
    padding-left: 5px;
  }
  .fa-question-circle{
    padding-left: 0.5rem;
    color: #517aa1;
    cursor: help;
  }
</style>

<style>
  .tooltip_link{
    color: #6495ED;
    font-size: 0.86em;
    padding-top: 0.3em;
  }
</style>
